import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import * as pageData from "./PageData";

var myVar = null;

const underway = 0;
const promptIncomplete = 1;
const promptMoreTime = 2;

export default class NumericalReasoning extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.forceNumericKeyPressHandler = this.forceNumericKeyPressHandler.bind(this);
        this.textChange = this.textChange.bind(this);
        this.handleModalProceed = this.handleModalProceed.bind(this);
        this.handleModalReturn = this.handleModalReturn.bind(this);

        const arr = [];

        for (let i = 0; i < pageData.numericalReasoningTestPages; i++) {
            arr.push(pageData.nullOption);
        }

        this.state = {
            memory: arr,
            secondsRemaining: 1200,
            completedState: underway
        };
    }

    componentDidMount() {
        this.afterUpdate();

        myVar = setInterval(this.updateTimer.bind(this), 1000);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    updateTimer() {
        const secondsRemaining = this.state.secondsRemaining;

        try {
            if (secondsRemaining > 0) {
                this.setState({ secondsRemaining: secondsRemaining - 1 });
            } else {
                clearTimeout(myVar);
                this.props.next({ response: pageData.skipRemaining });
            }
        } catch (e) {
            clearTimeout(myVar);
        }
    }

    forceNumericKeyPressHandler(e) {
        if (e.charCode >= 48 && e.charCode <= 57) {
            return false;
        }
        e.preventDefault();
        return true;
    }

    textChange(e) {
        const arr = this.state.memory;
        const value = e.target.value;

        arr[this.props.content.index] = value.length > 0 ? parseInt(value, 10) : pageData.nullOption;

        this.setState({ memory: arr });
    }

    handleModalProceed() {
        /*if (this.state.completedState === promptIncomplete) {*/
            /*this.props.next({ response: pageData.skipRemaining });*/            
            /*this.props.next({ response: this.state.memory[this.props.content.index] });                        
        } else {
            this.props.next({ response: this.state.memory[this.props.content.index] });
        }*/

        let response = this.state.memory[this.props.content.index];

        if (response !== pageData.nullOption && response !== this.props.content.answer) {
            response *= -1;
        }

        this.props.next({ response: response });
    }

    handleModalReturn() {
        this.setState({ completedState: underway });
    }

    interceptClick(type) {
        if (type === "next") {
            let response = this.state.memory[this.props.content.index];

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }

            this.props.next({ response: response });
            return true;
        }
        else if (type === "back") {
            let response = this.state.memory[this.props.content.index];

            if (response == null || response == pageData.nullOption)
            {
                return false;
            }

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }
            this.props.previous({ response: response });
            return false;
        }
        else if (type === "prev") {
            clearTimeout(myVar);
        }
        else if (type === "end") {
            const count = this.state.memory.reduce((accumulator, currentValue) => accumulator + (currentValue === pageData.nullOption ? 1 : 0), 0);

            if (count === 0) {
                this.setState({ completedState: promptMoreTime });
            } else {
                this.setState({ completedState: promptIncomplete });
            }
        }

        return false;
    }

    render() {
        const p = this.props;
        const forceNumericKeyPressHandler = this.forceNumericKeyPressHandler;
        const textChange = this.textChange;
        const handleModalReturn = this.handleModalReturn;
        const handleModalProceed = this.handleModalProceed;

        const progressStyle = {
            width: `${p.content.index * (100 / pageData.numericalReasoningTestPages)}%`
        };

        return (
            <div className="test-page-content-inner test-page-numerical-reasoning">
                <div className="test-content">
                    {renderPractice(p, this.state, forceNumericKeyPressHandler, textChange, handleModalReturn, handleModalProceed)}
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, forceNumericKeyPressHandler, textChange, handleModalReturn, handleModalProceed) {
    const sourceIndex = props.content.index;
    const time = pageData.secondsToTime(state.secondsRemaining);

    let text = state.memory[sourceIndex];

    if (text === pageData.nullOption) {
        text = "";
    }

    return (
        <div className="test-content-inner">
            <h2 className="question-title">Question</h2>
            <div className="question">
                {props.content.question}
            </div>
            {renderOptions(props.content.options)}
            {renderTimer(time)}
            <h2 className="answer-title">Answer</h2>
            <input type="text" className="answer-text" maxLength="2" onKeyPress={forceNumericKeyPressHandler} value={text} onChange={textChange} />
            {renderIncompleteModal(state, time, handleModalReturn, handleModalProceed)}
        </div>
    );
}

function renderIncompleteModal(state, time, handleModalReturn, handleModalProceed) {
    return (
        <Modal show={(state.completedState > underway)}>
            <Modal.Header>
                <Modal.Title>End Test</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderModalMessage(state, time)}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="default" onClick={handleModalReturn}>No thanks</Button>
                <Button bsStyle="success" onClick={handleModalProceed}>Yes, I'm sure</Button>
            </Modal.Footer>
        </Modal>
    );
}

function renderModalMessage(state, time) {
    if (state.completedState === promptIncomplete) {
        return (
            <div>Are you certain that you want to end the test without answering all the questions?</div>
        );
    }

    return (
        <div>You still have {time} left. Are you sure you want to end the test?</div>
    );
}

function renderOptions(elems) {
    if (elems.length === 0) {
        return null;
    }

    const items = elems.map(function (elem, index) {
        return renderOption(elem, index);
    });

    return (<div className="options">{items}</div>);
}

function renderOption(elem, sourceIndex, optionValue) {
    const key = `option${sourceIndex}-${optionValue}`;
    return <div key={key}>{elem.text}</div>;
}

function renderTimer(time) {
    return (
        <div className="timer">
            <div className="timer-title">Time remaining:</div>
            <div className="timer-value">{time}</div>
        </div>
    );
}
